import { render, staticRenderFns } from "./ContextNavigator.vue?vue&type=template&id=2b517054"
import script from "./ContextNavigator.vue?vue&type=script&lang=js"
export * from "./ContextNavigator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports